module.exports = __webpack_public_path__ + "img/heart2.8e340916.svg";